import React from "react";

const items = [
  "Activate Then Elevate",
  "AI Agents",
  "AI Chatbots",
  "Workflow Automation",
  "AI Adoption Training",
  "The Possibilities? Endless",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="relative py-6 border-y border-fuchsia-500/10 bg-white overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-extrabold text-2xl sm:text-4xl tracking-tight text-slate-900/90 px-8">
              {t}
            </span>
            <span
              className="w-2.5 h-2.5 rounded-full"
              style={{ background: "linear-gradient(90deg,#E933C6,#8B5CF6)" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
